<section class="csa-container">

  <span class="h4-regular text-center">
    Shop with purpose-your one-stop destination for fresh, local , organic food that nourishes your family and builds a
    stronger, sustainable community of farmers and mindful members.
  </span>

  <div class="csa-container__cards">

    @for (item of list(); track $index) {

    <div class="card" (click)="selectCard(item.id)"
      [class.card-selected]="item.id === this.premiumMembershipSelected()">

      <div class="content">
        <div class="recommended">
          @if (item.display) {

          @if (item.isRecommended) {
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="#F7901E">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path
              d="M8.243 7.34l-6.38 .925l-.113 .023a1 1 0 0 0 -.44 1.684l4.622 4.499l-1.09 6.355l-.013 .11a1 1 0 0 0 1.464 .944l5.706 -3l5.693 3l.1 .046a1 1 0 0 0 1.352 -1.1l-1.091 -6.355l4.624 -4.5l.078 -.085a1 1 0 0 0 -.633 -1.62l-6.38 -.926l-2.852 -5.78a1 1 0 0 0 -1.794 0l-2.853 5.78z" />
          </svg>
          }

          <span>
            {{item.display}}
          </span>

          @if (item.isRecommended) {
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="#F7901E">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path
              d="M8.243 7.34l-6.38 .925l-.113 .023a1 1 0 0 0 -.44 1.684l4.622 4.499l-1.09 6.355l-.013 .11a1 1 0 0 0 1.464 .944l5.706 -3l5.693 3l.1 .046a1 1 0 0 0 1.352 -1.1l-1.091 -6.355l4.624 -4.5l.078 -.085a1 1 0 0 0 -.633 -1.62l-6.38 -.926l-2.852 -5.78a1 1 0 0 0 -1.794 0l-2.853 5.78z" />
          </svg>
          }
          }
        </div>

        <h1 class="title">
          {{item.name}}
        </h1>

        <div class="text-center">

          <div class="items">
            @for (benefit of item.benefits; track $index) {
            <span>{{benefit}}</span>
            }
          </div>
        </div>
      </div>

      <div class="radio">
        @if (item.id === this.premiumMembershipSelected()) {
        <span class="material-symbols-outlined text-white">
          check
        </span>
        }
      </div>

    </div>
    }

  </div>

  <button type="button" class="btn btn-secondary" (click)="next()">
    Continue
  </button>

</section>
